"use client";

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { TermsOfService } from "@/components/application/userRegister/TermsOfService";
import { Dialog, DialogContent } from "@/components/common/Dialog";
export function TermsModal(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Dialog.Trigger type="button" className="contents text-link cursor-pointer text-left">{children}</Dialog.Trigger>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dialog.Title className="text-lg font-semibold shrink-0">TERMOS DE USO</Dialog.Title>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Dialog.Description className="flex-1 overflow-y-auto pr-2" asChild={true}><div className="flex py-2 leading-normal text-gray-500"><TermsOfService /></div></Dialog.Description>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Dialog.Portal><DialogContent className="lg:max-w-3/6 w-10/12 h-3/5">{t2}{t3}<div className="shrink-0 mt-6 flex justify-end"><Dialog.Close type="button" className="px-6 py-1 outline-none bg-primary-500 hover:bg-primary-600 font-medium text-white rounded transition-colors cursor-pointer">Fechar</Dialog.Close></div></DialogContent></Dialog.Portal>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <Dialog.Root>{t1}{t4}</Dialog.Root>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}